"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
  mutation setCustomerNote($customerId: Int!, $note: String!){
    saveCommentFromCoach(trainee: $customerId, comments: $note) {
      success
    }
  }
`;
//# sourceMappingURL=setCustomerNoteMutation.js.map